<template>
    <div class="main-container flex column w-full gap-20" v-if="loaded">
        <div class="header-main flex align-center justify-center relative w-full">
            <h1 class="no-wrap m-0">
                Due Diligence 
            </h1> 

            <span class="dd-status mb-10" :class="dueDiligenceRecord.status">
                {{ dueDiligenceRecord.status.charAt(0).toUpperCase() + dueDiligenceRecord.status.slice(1) }}
            </span>
            <div class='absolute right-0 flex gap-5' v-if="!props.reviewMode">
                <button 
                    v-if="store.state.user && ['approved'].includes(dueDiligenceRecord.status) && !store.state.editDueDiligence"
                    class="buttons w-content" 
                    @click="enableEdit"
                >
                    Edit
                </button>
                <button 
                    v-if="store.state.user"
                    class="buttons w-content" 
                    @click="enableDelete"
                >
                    Delete
                </button>
            </div>
        </div>
      
        <div class="table-wrapper flex gap-20 column w-full" id="pdfContent">
            <div class="section w-full flex column"> 
                <span class="section-header">1. Company Information</span>
                <div class="due-elements">
                    <DueDiligenceElement
                        :id="dueDiligenceCompany._id"
                        :reviewMode="reviewMode"
                    />
                </div>
            </div>
            <div class="section w-full flex column"> 
                <div class="flex justify-between w-full">
                    <span class="section-header">2. Company directors – Corporate persons (if applicable)<br>
                        (if more than one – please complete additional form(s) in the end of the form)</span>
                    <button v-if='editable' class='w-content h-fit' @click="AddNewElement('corporate_person')">Add New</button>
                </div>
                <div class="due-elements">
                    <DueDiligenceElement 
                        v-for="(director, index) in dueDiligenceElements.filter(el => el.type.value == 'corporate_person')" :key="director._id"
                        :id="director._id"
                        :reviewMode="reviewMode"
                    />
                </div>
            </div>

            <div class="section w-full flex column"> 
                <div class="flex justify-between w-full">
                    <span class="section-header">3. Company directors – Private persons<br>
                    (if more than one – please complete additional form(s) in the end of the form)</span>

                    <button v-if='editable' class='w-content h-fit' @click="AddNewElement('director')">Add New</button>
                </div>

                <div class="due-elements">
                    <DueDiligenceElement v-for="(director, index) in dueDiligenceElements.filter(el => el.type.value == 'director')" :key="director._id"
                        :id="director._id"
                        :reviewMode="reviewMode"
                    />
                </div>
            </div>
            <div class="section w-full flex column"> 
                <div class="flex justify-between w-full">
                    <span class="section-header">4. Shareholders – corporate persons (if applicable) <br>
                        (if more than one – please complete additional form(s) in the end of the form)</span>
                    <button v-if='editable' class='w-content h-fit' @click="AddNewElement('corporate_shareholder')">Add New</button>
                </div>
                <div class="due-elements">
                    <DueDiligenceElement v-for="(director, index) in dueDiligenceElements.filter(el => el.type.value == 'corporate_shareholder')" :key="director._id"
                        :id="director._id"
                        :reviewMode="reviewMode"
                    />
                </div>
            </div>
            <div class="section w-full flex column"> 
                <div class="flex justify-between w-full">
                    <span class="section-header">5. Shareholders – Private persons <br>
                        (if more than one – please complete additional form(s) in the end of the form)
                    </span>
                    <button v-if='editable' class='w-content h-fit' @click="AddNewElement('shareholder')">Add New</button>
                </div>
                <div class="due-elements">    
                    <DueDiligenceElement v-for="(director, index) in dueDiligenceElements.filter(el => el.type.value == 'shareholder')" :key="director._id"
                        :id="director._id"
                        :reviewMode="reviewMode"
                    />
                </div>
            </div>
            <div class="section w-full flex column"> 
                <div class="flex justify-between w-full">
                    <span class="section-header">6. Beneficiary owners – Private persons (if applicable) <br>
                        (if more than one – please complete additional form(s) in the end of the form)
                    </span>
                    <button v-if='editable' class='w-content h-fit' @click="AddNewElement('beneficiary')">Add New</button>
                </div>
                <div class="due-elements">
                    <DueDiligenceElement v-for="(director, index) in dueDiligenceElements.filter(el => el.type.value == 'beneficiary')" :key="director._id"
                        :id="director._id"
                        :reviewMode="reviewMode"
                    />
                </div>
            </div>

            <div class="section w-full flex column"> 
                <span class="section-header yes-no">7. Additinal Information<br>
                    Note: A PEP is a natural person who is or has been entrusted with a prominent public function <br>and includes his immediate family members or persons known to be close associates of such persons.
                </span>
                <table class="info-table w-full">
                    <tr>
                        <th class="width-big"></th>
                        <td class="small text-center">YES</td>
                        <td class="small text-center">NO</td>
                    </tr>
                    <tr>
                        <th class="width-big" :rowspan="peps_present ? 2 : 1">Are there any PEPs identified in the Company?
                            <br><br>
                            If yes, please provide the following details: <br>
                            a) Full Name; <br>
                            b) Passport number; <br>
                            c) Public office description;<br>
                            d) Role or type of PEP - relation and coutnry;<br>
                            e) Date when office was assumed/left<br><br>

                        </th>
                        <td class="small" :class="mainInfo?.peps_present?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="YES-peps_present" 
                                style="margin: 0 5px"
                                name="peps_present"
                                :checked="mainInfo?.peps_present?.value == 'YES'"
                                value="YES"
                                :disabled="!editable"
                                @change="handleChange('peps_present', 'YES')"
                            >
                        </td>
                        <td class="small" :class="mainInfo?.peps_present?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="NO-peps_present" 
                                style="margin: 0 5px"
                                name="peps_present"
                                :checked="mainInfo?.peps_present?.value == 'NO'"
                                value="NO" 
                                @change="handleChange('peps_present', 'NO')"
                                :disabled="!editable"
                            >
                            <div v-if="mainInfo?.peps_present?.error" class="text-red-500 text-left">
                                {{ mainInfo?.peps_present?.error }}
                            </div>
                        </td>
                    </tr>
                    <tr v-if="peps_present">
                        <td colspan="2" >
                            <!-- {{ editable }} -->
                            <CommentSection 
                                attrId='peps_present_details' 
                                class="markdown-content" 
                                :class="{
                                    'disabled' : !editable,
                                    'border-error': mainInfo?.peps_present_details?.error
                                }"
                                :disabled="!editable"
                                :commentSection="mainInfo?.peps_present_details?.new_value || mainInfo?.peps_present_details?.value"
                                @changeinput="quillContentComment" 
                            />
                            <div v-if="mainInfo?.peps_present_details?.error" class="text-red-500 text-left">
                                {{ mainInfo?.peps_present_details?.error }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th class="width-big" :rowspan="past_present ? 2 : 1"> Is there any information about the custome or director/s shareholder/s past or present, that may lead to concern for the Company ?
                        </th>
                        <td class="small" :class="mainInfo?.interesting_past?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="YES-interesting_past" 
                                style="margin: 0 5px"
                                name="interesting_past"
                                :checked="mainInfo?.interesting_past?.value == 'YES'"
                                value="YES" 
                                @change="handleChange('interesting_past', 'YES')"
                                :disabled="!editable"
                            >
                        </td>
                        <td class="small" :class="mainInfo?.interesting_past?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="NO-interesting_past" 
                                style="margin: 0 5px"
                                name="interesting_past"
                                :checked="mainInfo?.interesting_past?.value == 'NO'"
                                value="NO" 
                                @change="handleChange('interesting_past', 'NO')"
                                :disabled="!editable"
                            >
                            <div v-if="mainInfo?.interesting_past?.error" class="text-red-500 text-left">
                                {{ mainInfo?.interesting_past?.error }}
                            </div>
                        </td>
                    </tr>
                    <tr v-if="past_present">
                        <td colspan="2">
                            <CommentSection 
                                attrId='interesting_past_details' 
                                class="markdown-content" 
                                :class="{
                                    'disabled' : !editable,
                                    'border-error': mainInfo?.interesting_past_details?.error
                                }"
                                :disabled="!editable"
                                :commentSection="mainInfo?.interesting_past_details?.new_value || mainInfo?.interesting_past_details?.value"
                                @changeinput="quillContentComment" 
                            />
                            <div v-if="mainInfo?.interesting_past_details?.error" class="text-red-500 text-left">
                                {{ mainInfo?.interesting_past_details?.error }}
                            </div>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="section w-full flex column"> 
                <span class="section-header yes-no">8. AML & Compliance Statement Compliance<br>
                </span>
                <table class="info-table w-full">
                    <tr>
                        <th class="width-big"></th>
                        <td class="small text-center">YES</td>
                        <td class="small text-center">NO</td>
                    </tr>
                    <tr>
                        <th class="width-big">Does the entity maintain an internal AML Policy? </th>
                        <td class="small" :class="mainInfo?.internal_aml_policy?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="YES-internal_aml_policy" 
                                style="margin: 0 5px"
                                name="internal_aml_policy"
                                :checked="mainInfo?.internal_aml_policy?.value == 'YES'"
                                value="YES"
                                :disabled="!editable"
                                @change="handleChange('internal_aml_policy', 'YES')"
                            >
                        </td>
                        <td class="small" :class="mainInfo?.internal_aml_policy?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="NO-internal_aml_policy" 
                                style="margin: 0 5px"
                                name="internal_aml_policy"
                                :checked="mainInfo?.internal_aml_policy?.value == 'NO'"
                                value="NO" 
                                @change="handleChange('internal_aml_policy', 'NO')"
                                :disabled="!editable"
                            >
                            <div v-if="mainInfo?.internal_aml_policy?.error" class="text-red-500 text-left">
                                {{ mainInfo?.internal_aml_policy?.error }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th class="width-big">Is there an appointed MLRO/Compliance Officer? 
                        </th>
                        <td class="small" :class="mainInfo?.compliance_officer_present?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="YES-compliance_officer_present" 
                                style="margin: 0 5px"
                                name="compliance_officer_present"
                                :checked="mainInfo?.compliance_officer_present?.value == 'YES'"
                                value="YES" 
                                @change="handleChange('compliance_officer_present', 'YES')"
                                :disabled="!editable"
                            >
                          
                        </td>
                        <td class="small" :class="mainInfo?.compliance_officer_present?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="NO-compliance_officer_present" 
                                style="margin: 0 5px"
                                name="compliance_officer_present"
                                :checked="mainInfo?.compliance_officer_present?.value == 'NO'"
                                value="NO" 
                                @change="handleChange('compliance_officer_present', 'NO')"
                                :disabled="!editable"
                            >
                            <div v-if="mainInfo?.compliance_officer_present?.error" class="text-red-500 text-left">
                                {{ mainInfo?.compliance_officer_present?.error }}
                            </div>
                        </td>
                    </tr>
                    <tr v-if="mainInfo?.compliance_officer_present?.new_value == 'YES' || (mainInfo?.compliance_officer_present?.value == 'YES' && mainInfo?.compliance_officer_present?.new_value !== 'NO')">
                        <th>Name & Contact of MLRO  Name:</th>
                        <td colspan="2">
                            <InpComponent 
                                @inputChange="inputChangeFunc"
                                :value="mainInfo?.compliance_officer_name.new_value || mainInfo?.compliance_officer_name?.value"
                                key_ref="compliance_officer_name" 
                                type="text" 
                                placeholder="" 
                                :error="mainInfo?.compliance_officer_name?.error"
                                :disabled="!editable"
                            />
                        </td>
                    </tr>
                    <tr v-if="mainInfo?.compliance_officer_present?.new_value == 'YES' || (mainInfo?.compliance_officer_present?.value == 'YES' && mainInfo?.compliance_officer_present?.new_value !== 'NO')">
                        <th>Contact email address:</th>
                        <td colspan="2">
                            <InpComponent 
                                @inputChange="inputChangeFunc"
                                :value="mainInfo?.compliance_officer_email.new_value || mainInfo?.compliance_officer_email?.value"
                                key_ref="compliance_officer_email" 
                                type="text" 
                                placeholder="" 
                                :error="mainInfo?.compliance_officer_email?.error"
                                :disabled="!editable"
                            />
                        </td>
                    </tr>
                    <tr v-if="mainInfo?.compliance_officer_present?.new_value == 'YES' || (mainInfo?.compliance_officer_present?.value == 'YES' && mainInfo?.compliance_officer_present?.new_value !== 'NO')">
                        <th>Contact number:</th>
                        <td colspan="2">
                            <InpComponent 
                                @inputChange="inputChangeFunc"
                                :value="mainInfo?.compliance_officer_phone.new_value || mainInfo?.compliance_officer_phone?.value"
                                key_ref="compliance_officer_phone" 
                                type="text" 
                                placeholder="" 
                                :error="mainInfo?.compliance_officer_phone?.error"
                                :disabled="!editable"
                            />
                        </td>
                    </tr>
                    <tr>
                        <th class="width-big">
                            Does the entity perform customer KYC? 
                        </th>
                        <td class="small" :class="mainInfo?.has_customer_kyc?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="YES-has_customer_kyc" 
                                :checked="mainInfo?.has_customer_kyc?.value == 'YES'"
                                style="margin: 0 5px"
                                name="has_customer_kyc"
                                value="YES" 
                                @change="handleChange('has_customer_kyc', 'YES')"
                                :disabled="!editable"
                            >
                        </td>
                        <td class="small" :class="mainInfo?.has_customer_kyc?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="NO-has_customer_kyc" 
                                :checked="mainInfo?.has_customer_kyc?.value == 'NO'"
                                style="margin: 0 5px"
                                name="has_customer_kyc"
                                value="NO" 
                                @change="handleChange('has_customer_kyc', 'NO')"
                                :disabled="!editable"
                            >
                            <div v-if="mainInfo?.has_customer_kyc?.error" class="text-red-500 text-left">
                                {{ mainInfo?.has_customer_kyc?.error }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <th class="width-big">
                            Is customer’s PEP screening conducted?
                        </th>
                        <td class="small" :class="mainInfo?.customer_pep_conducted?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="YES-customer_pep_conducted" 
                                :checked="mainInfo?.customer_pep_conducted?.value == 'YES'"
                                style="margin: 0 5px"
                                name="customer_pep_conducted"
                                value="YES" 
                                @change="handleChange('customer_pep_conducted', 'YES')"
                                :disabled="!editable"
                            >
                        </td>
                        <td class="small" :class="mainInfo?.customer_pep_conducted?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="NO-customer_pep_conducted" 
                                :checked="mainInfo?.customer_pep_conducted?.value == 'NO'"
                                style="margin: 0 5px"
                                name="customer_pep_conducted"
                                value="NO" 
                                @change="handleChange('customer_pep_conducted', 'NO')"
                                :disabled="!editable"
                            >
                            <div v-if="mainInfo?.customer_pep_conducted?.error" class="text-red-500 text-left">
                                {{ mainInfo?.customer_pep_conducted?.error }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <th class="width-big">
                            Is customer’s transaction monitoring conducted?  
                        </th>
                        <td class="small" :class="mainInfo?.customer_transaction_monitoring?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="YES-customer_transaction_monitoring" 
                                :checked="mainInfo?.customer_transaction_monitoring?.value == 'YES'"
                                style="margin: 0 5px"
                                name="customer_transaction_monitoring"
                                value="YES" 
                                @change="handleChange('customer_transaction_monitoring', 'YES')"
                                :disabled="!editable"
                            >
                        </td>
                        <td class="small" :class="mainInfo?.customer_transaction_monitoring?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="NO-customer_transaction_monitoring" 
                                :checked="mainInfo?.customer_transaction_monitoring?.value == 'NO'"
                                style="margin: 0 5px"
                                name="customer_transaction_monitoring"
                                value="NO" 
                                @change="handleChange('customer_transaction_monitoring', 'NO')"
                                :disabled="!editable"
                            >
                            <div v-if="mainInfo?.customer_transaction_monitoring?.error" class="text-red-500 text-left">
                                {{ mainInfo?.customer_transaction_monitoring?.error }}
                            </div>
                        </td>
                    </tr>


                    <tr>
                        <th class="width-big">
                            Are suspicious transactions reported to the authorities?  	
                        </th>
                        <td class="small" :class="mainInfo?.suspicious_activity_reported?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="YES-suspicious_activity_reported" 
                                :checked="mainInfo?.suspicious_activity_reported?.value == 'YES'"
                                style="margin: 0 5px"
                                name="suspicious_activity_reported"
                                value="YES" 
                                @change="handleChange('suspicious_activity_reported', 'YES')"
                                :disabled="!editable"
                            >
                        </td>
                        <td class="small" :class="mainInfo?.suspicious_activity_reported?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="NO-suspicious_activity_reported" 
                                :checked="mainInfo?.suspicious_activity_reported?.value == 'NO'"
                                style="margin: 0 5px"
                                name="suspicious_activity_reported"
                                value="NO" 
                                @change="handleChange('suspicious_activity_reported', 'NO')"
                                :disabled="!editable"
                            >
                            <div v-if="mainInfo?.suspicious_activity_reported?.error" class="text-red-500 text-left">
                                {{ mainInfo?.suspicious_activity_reported?.error }}
                            </div>
                        </td>
                    </tr>

                </table>
            </div>


            <div class="section w-full flex column"> 
                <span class="section-header yes-no">9. FATCA<br>
                </span>
                <table class="info-table w-full">
                    <tr>
                        <th class="width-big"></th>
                        <td class="small text-center">YES</td>
                        <td class="small text-center">NO</td>
                    </tr>
                    <tr>
                        <th class="width-big">Is the applicant for business a U.S. Entity?</th>
                        <td class="small" :class="mainInfo?.us_applicant?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="YES-us_applicant" 
                                style="margin: 0 5px"
                                name="us_applicant"
                                :checked="mainInfo?.us_applicant?.value == 'YES'"
                                value="YES"
                                :disabled="!editable"
                                @change="handleChange('us_applicant', 'YES')"
                            >
                        </td>
                        <td class="small" :class="mainInfo?.us_applicant?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="NO-us_applicant" 
                                style="margin: 0 5px"
                                name="us_applicant"
                                :checked="mainInfo?.us_applicant?.value == 'NO'"
                                value="NO" 
                                @change="handleChange('us_applicant', 'NO')"
                                :disabled="!editable"
                            >
                            <div v-if="mainInfo?.us_applicant?.error" class="text-red-500 text-left">
                                {{ mainInfo?.us_applicant?.error }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <th class="width-big">Is the income of the applicant for
                            business effectively connected with the
                            conduct of a trade or business in the
                            United States?
                        </th>
                        <td class="small" :class="mainInfo?.us_applicant_connect?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="YES-us_applicant_connect" 
                                style="margin: 0 5px"
                                name="us_applicant_connect"
                                :checked="mainInfo?.us_applicant_connect?.value == 'YES'"
                                value="YES" 
                                @change="handleChange('us_applicant_connect', 'YES')"
                                :disabled="!editable"
                            >
                          
                        </td>
                        <td class="small" :class="mainInfo?.us_applicant_connect?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="NO-us_applicant_connect" 
                                style="margin: 0 5px"
                                name="us_applicant_connect"
                                :checked="mainInfo?.us_applicant_connect?.value == 'NO'"
                                value="NO" 
                                @change="handleChange('us_applicant_connect', 'NO')"
                                :disabled="!editable"
                            >
                            <div v-if="mainInfo?.us_applicant_connect?.error" class="text-red-500 text-left">
                                {{ mainInfo?.us_applicant_connect?.error }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <th class="width-big">
                            Is the income of the applicant for
                            business effectively connected but is not
                            subject to tax under an applicable income
                            tax treaty?
                        </th>
                        <td class="small" :class="mainInfo?.us_applicant_tag_related?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="YES-us_applicant_tag_related" 
                                :checked="mainInfo?.us_applicant_tag_related?.value == 'YES'"
                                style="margin: 0 5px"
                                name="us_applicant_tag_related"
                                value="YES" 
                                @change="handleChange('us_applicant_tag_related', 'YES')"
                                :disabled="!editable"
                            >
                        </td>
                        <td class="small" :class="mainInfo?.us_applicant_tag_related?.error ? 'border border-red-500' : ''">
                            <input 
                                type="radio" 
                                id="NO-us_applicant_tag_related" 
                                :checked="mainInfo?.us_applicant_tag_related?.value == 'NO'"
                                style="margin: 0 5px"
                                name="us_applicant_tag_related"
                                value="NO" 
                                @change="handleChange('us_applicant_tag_related', 'NO')"
                                :disabled="!editable"
                            >
                            <div v-if="mainInfo?.us_applicant_tag_related?.error" class="text-red-500 text-left">
                                {{ mainInfo?.us_applicant_tag_related?.error }}
                            </div>
                        </td>
                    </tr>


                </table>
            </div>

            <div class="section w-full flex column"> 
                <span class="section-header">With My Signature, I state that <br><br>
                    a. I am authorized to duly execute this questionnaire on behalf of the Company that is submitting this
                    questionnaire. <br><br>
                    b. I have personally supplied the information contained in this questionnaire. <br><br>
                    c. I confirm, to the best of my knowledge, that all information supplied is correct.
                </span>
                <div class="w-full">
                    <table class="info-table w-full">
                        <tr>
                            <th>Full Name</th>
                            <td>
                                <InpComponent 
                                    @inputChange="inputChangeFunc"
                                    :value="mainInfo?.filler_full_name.new_value || mainInfo?.filler_full_name?.value"
                                    key_ref="filler_full_name" 
                                    type="text" 
                                    placeholder="" 
                                    :error="mainInfo?.filler_full_name?.error"
                                    :disabled="!editable"
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>Position</th>
                            <td>
                                <InpComponent 
                                    @inputChange="inputChangeFunc"
                                    :value="mainInfo.position?.new_value || mainInfo.position?.value"
                                    key_ref="position" 
                                    type="text" 
                                    placeholder="" 
                                    :error="mainInfo.position?.error"
                                    :disabled="!editable"
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>Date when signed</th>
                            <td>
                                <InpComponent 
                                    @inputChange="inputChangeFunc"
                                    :value="mainInfo.date_when_signed?.new_value || mainInfo.date_when_signed?.value"
                                    key_ref="date_when_signed" 
                                    type="date" 
                                    placeholder="" 
                                    :error="mainInfo.date_when_signed?.error"
                                    :disabled="!editable"
                                />
                            </td>
                        </tr>

                    </table>
                </div>
            </div>
            
        </div>
        <div class="submit-section" >
            <button class="submit fit-content no-margin" @click="() => downloadPdf()">Download PDF</button>
        </div>
        <DueDiligenceDocs/>
        <div class="submit-section" v-if="editable && !['approved', 'submitted'].includes(dueDiligenceRecord.status) && !user">
            <button class="submit fit-content no-margin" @click="() => submitForm()">Submit</button>
        </div>
        <div class="submit-section buttons w-full flex row gap-10" v-if="store.state.user && ['submitted'].includes(dueDiligenceRecord.status)">
            <button class="button w-content margin-left-auto" @click="() => handleStateChange('rejected')">
                Reject
            </button>
            <button class="button w-content" @click="() => handleStateChange('approved')">
                Approve
            </button>
        </div>
        <div class="notification-section" :class="`${notificationOpen ? 'opened': 'closed'}`" v-if="dueDiligenceRecord.comments.length">
            <div class="close-section">
                <img src="@/assets/menu-close.svg" alt="Close" @click="notificationOpen = !notificationOpen">
            </div>
            <div class="notifications">
                <div class="message" v-for="(comment, index) in dueDiligenceRecord.comments" :key="index">
                    
                    <div class="text-left comment-response" >
                        <div class="message-content" v-html="comment.comment"></div>
                    </div>
                    <div class="message-date margin-left-auto">{{ dayjs(comment.date).format('MMM DD, YYYY hh:mm A') }}</div>
                </div>
            </div>
        </div>
        <PopupCover v-if="deleteDueDiligence" @close="() => deleteDueDiligence = !deleteDueDiligence">
            <PopupBody class="confirm-submit" @close="() => deleteDueDiligence = !deleteDueDiligence">
                <template #header>Due Diligence Form Deletion</template>
                <template #body>
                    <div class="body-content flex column gap-10">
                        <div class="header text-left">Are you sure you want to delete this due diligence form ?</div>
                        <div class="buttons flex justify-end gap-10">
                            <button class="margin-left-auto button transparent w-content" @click="() => deleteDueDiligence = false">Cancel</button>
                            <button class="save-button" @click="deleteReport">Yes, Delete</button>
                        </div>
                    </div>
                </template>
            </PopupBody>
        </PopupCover>

        <PopupCover v-if="confirmApprove" @close="() => confirmApprove = !confirmApprove">
            <PopupBody class="confirm-submit approve-review" :class="missingFiles.length > 0 ? 'missing-files' : ''" @close="() => confirmApprove = !confirmApprove">
                <template #header>Due Diligence Form Confirmation</template>
                <template #body>
                    <div class="body-content flex column gap-10">
                        <div class="header font-20 text-left">Are you sure you want to approve this due diligence form ?</div>
                        <div v-if="missingFiles.length" class="header text-left" :class="ignoreWarning ? 'missing-files-section' : ''">
                            
                            <div class="header text-left"><b> List of files that are not uploaded:</b></div>
                            <div class="pl-30">
                                <div class='missing-file' v-for="file of missingFiles">
                                    {{ dueDiligenceDocumentType(file.type) }} <text v-if="file.for"><b>{{ file.for }}</b></text>
                                </div>
                            </div>

                            <div class="header text-left pt-10"><b> List of files that are waiting for review:</b></div>
                            
                            <div class="pl-30">
                                <div class='missing-file' v-for="file of kyc_files.filter(file => file.status == 'pending' && file.dueDiligence)">
                                    {{ dueDiligenceDocumentType(file.documentType) }}
                                </div>
                            </div>

                            <button v-if="ignoreWarning == false" class="button margin-left-auto w-content" @click="ignoreWarning=true">Proceed anyway</button>
                        </div>
                        
                        <div class="buttons flex justify-end gap-10">
                            <button class="margin-left-auto button transparent w-content" @click="() => {confirmApprove = false; ignoreWarning = false}">Cancel</button>
                            <button :disabled="missingFiles.length > 0 && !ignoreWarning" class="save-button" @click="updateReport('approved')">Yes, Approve</button>
                        </div>
                    </div>
                </template>
            </PopupBody>
        </PopupCover>
        <PopupCover v-if="confirmReject" @close="() => confirmReject = !confirmReject">
            <PopupBody class="confirm-submit" @close="() => confirmReject = !confirmReject">
                <template #header>Due Diligence Form Rejection</template>
                <template #body>
                    <div class="body-content flex column gap-10">
                        <div class="header text-left">Please State Below the reason of rejection</div>
                        <CommentSection @changeinput="quillContent" class="markdown-content" :placeholder="'Rejection Reason'"/>
                        <div class="buttons flex justify-end gap-10">
                            <button class="margin-left-auto button transparent w-content" @click="() => {confirmReject = false;}">Cancel</button>
                            <button class="save-button" @click="updateReport('rejected')">Send</button>
                        </div>
                    </div>
                </template>
            </PopupBody>
        </PopupCover>
        <PopupCover v-if="showSubmit" @close="() => showSubmit = !showSubmit">
            <PopupBody class="confirm-submit" @close="() => showSubmit = !showSubmit">
                <template #header>Registration Form Submit</template>
                <template #body>
                    <div class="body-content flex column gap-10">
                        <div v-if="missingFiles.length && !ignoreWarning" class="header text-left">
                            <div class="header text-left"><b> Please attach the following files before submitting:</b></div>
                            <div class="pl-30">
                                <div class='missing-file' v-for="file of missingFiles">
                                    {{ dueDiligenceDocumentType(file.type) }} <text v-if="file.for"><b>{{ file.for }}</b></text>
                                </div>
                            </div>
                            <button class="button margin-left-auto w-content" @click="ignoreWarning=true">Proceed anyway</button>
                        </div>
                        <div class="confirm-block" :class="missingFiles.length && !ignoreWarning ? 'missing' : ''">
                            <div class="header text-left">I, in my case as a duly authorised representative of <b>{{dueDiligenceCompany.company_name.new_value || dueDiligenceCompany.company_name.value}}</b> hereby confirm that:</div>
                            <div class="info-row flex align-start">
                                <input 
                                    class="pt-10"
                                    type="checkbox" 
                                    id="confirm"
                                    :disabled="missingFiles.length && !ignoreWarning"
                                    style="margin-top: 5px"
                                    name="confirm"
                                    :checked="aggree.checked"
                                    @change="() => aggree.checked = !aggree.checked">
                                    <div class="text-left">The information provided to <b>{{ companyName }}</b> the Company is correct, current and complete.</div>
                            </div>
                            <div class="info-row flex align-start">
                                <input 
                                    class="pt-10"
                                    type="checkbox" 
                                    id="confirm"
                                    :disabled="missingFiles.length && !ignoreWarning"
                                    style="margin-top: 5px"
                                    name="confirm"
                                    :checked="aggree.checked2"
                                    @change="() => aggree.checked2 = !aggree.checked2">
                                    <div class="text-left">I have read and understood and on behalf <b>{{dueDiligenceCompany.company_name.new_value || dueDiligenceCompany.company_name.value}}</b>, agree to the 
                                        <a>Services Terms and Conditions</a> the
                                        <a> Privacy Policy</a>,
                                        and all therein referenced documents and materials.

                                    </div>
                            </div>
                        </div>
                        <div class="buttons flex justify-end gap-10">
                            <button class="margin-left-auto button transparent w-content" @click="() => {aggree = {}; showSubmit = false;}">Cancel</button>
                            <button :disabled="!aggree.checked || !aggree.checked2 || changingState" class="save-button" @click="submitReport()">
                                <text v-if="!changingState">Submit</text>
                                <text v-else>Submiting...</text>
                            </button>
                        </div>
                    </div>
                </template>
            </PopupBody>
        </PopupCover>

        <PopupCover v-if="showAddPopup" @close="() => showAddPopup = false">
            <PopupBody @close="() => showAddPopup = false" v-if="!addingNewLoading"> 
                <template #header>Add new {{ nameMap(showAddPopup) }}</template>
                <template #body>
                    <div>
                        <InpComponent 
                            :value="newCompany.name" 
                            :key_ref="'name'"
                            @inputChange="inputChangeFuncNew"
                            :label="['corporate_person', 'corporate_shareholder'].includes(showAddPopup) ? 'Company Name' : 'Full Name'"
                            :error="nameError"
                        />
                        <button class="save-button" @click="SaveElement()">Save</button>
                    </div>
                </template>
            </PopupBody>
            <LoaderPopup v-else :message="`Adding New Element...`"/>
        </PopupCover>
        <div class="save-area" v-if="needUpdate">
            <div class="save-area-inner">
                <button class="add-new fit-content no-margin" v-if="!savingData" @click="Save()"> Save Progress</button>
                <button class="add-new fit-content no-margin" v-else disabled> Saving.. </button>
            </div>
        </div>
    </div>
    <div v-else>
        <h1>Loading...</h1>

    </div>
</template>

<script setup>

import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import InpComponent from '@/components/InpComponent.vue';
import API from '@/api/index.js';
import DueDiligenceDocs from './DueDiligenceDocs.vue';
import DueDiligenceElement from '@/components/DueDiligenceElement.vue';
import ConfirmationPopup from '@/components/ConfirmationPopup.vue';
import { commentValueChanged } from '@/utils/kyc_utils.js';
import CommentSection from '@/views/CommentSection.vue';
import PopupBody from '@/components/PopupBody.vue';
import LoaderPopup from '@/components/LoaderPopup.vue';
import PopupCover from '@/components/PopupCover.vue';
import dayjs from 'dayjs'
import html2pdf from 'html2pdf.js'; // Only if installed via npm

import { DUE_DILIGENCE_DOC_TYPES, dueDiligenceDocumentType } from '@/utils/kyc_utils';


const store = useStore();
const route = useRoute();
const router = useRouter();

const confirmApprove = ref(false);
const confirmReject = ref(false);
const rejectComment = ref('');
const changingState = ref(false);

const ignoreWarning = ref(false);

const props = defineProps(['id', 'item_id', 'reviewMode']);
const queryParams = computed( () => route.query )
const viewingToken = ref(queryParams.value.token)

const dueDiligenceRecord = computed(() => store.state.dueDiligenceRecord);
const dueDiligenceElements = computed(() => store.state.dueDiligenceElements);

const user = computed(() => store.state.user);
const showAddPopup = ref(false);
const addingNewLoading = ref(false);
const nameError = ref(false);
const newCompany = ref({
    name: '',
});

const savingData = ref(false);
const showSubmit = ref(false);

const companyName = ref('');
const initialStatedueDiligence = ref(null);
const initialStateElements = ref(null);
const notificationOpen = ref(false);

const deleteDueDiligence = ref(false);

const kyc_files = computed( () => {
    return store.state.kyc_files.filter( el => !!el.dueDiligence && el.file)
})
function enableDelete(){
    deleteDueDiligence.value = true;
}
function enableEdit(){
    store.state.editDueDiligence = true;
}
const peps_present = computed( () => {
    if (dueDiligenceRecord.value.peps_present.new_value === 'YES') {
        return true;
    }
    if (dueDiligenceRecord.value.peps_present.new_value === 'NO') {
        return false;
    }
    if (dueDiligenceRecord.value.peps_present.value === 'YES') {
        return true;
    }
    if (dueDiligenceRecord.value.peps_present.value === 'NO') {
        return false;
    }
    return false
})
const past_present = computed( () => {
    if (dueDiligenceRecord.value.interesting_past.new_value === 'YES') {
        return true;
    }
    if (dueDiligenceRecord.value.interesting_past.new_value === 'NO') {
        return false;
    }
    if (dueDiligenceRecord.value.interesting_past.value === 'YES') {
        return true;
    }
    if (dueDiligenceRecord.value.interesting_past.value === 'NO') {
        return false;
    }
    return false
})

const missingFiles = computed(() => {
    
    const types = JSON.parse(JSON.stringify(DUE_DILIGENCE_DOC_TYPES));
    const personFiles = {
        'certified_true_copy_of_passport': true,
        'proof_of_address': true,
    }

    for (let key in personFiles) {
        delete types[key]
    }

    let requiredFIles = types;
    for (let file of kyc_files.value) {
        if (file.documentType in requiredFIles) {
            delete requiredFIles[file.documentType];
        }
    }
    let personElements = dueDiligenceElements.value.filter(el => {
        return ['shareholder', 'director', 'beneficiary'].includes(el.type.value);
    });
    console.log('personElements', personElements, dueDiligenceElements);
    let required = Object.keys(requiredFIles).map(el => {
        return {type: el};
    });

    for( let el of personElements) {
        let passportCopy = kyc_files.value.find(file => file.documentType == 'certified_true_copy_of_passport' && file.dueDiligenceElement == el._id && file.status != 'rejected');
        let pfa = kyc_files.value.find(file => file.documentType == 'proof_of_address' && file.dueDiligenceElement == el._id && file.status != 'rejected');
        console.log('passportCopy', passportCopy, pfa, el);
        if (!passportCopy) {
            required.push({ type: 'certified_true_copy_of_passport', for: el.full_name.new_value || el.full_name.value });
        }
        if (!pfa) {
            required.push({ type: 'proof_of_address', for: el.full_name.new_value || el.full_name.value });
        }
        // if (el.type.value in personFiles) {
        //     delete requiredFIles[el.type.value];
        // }
    }
    return required;
});

const editable = computed(() => {
        if (props.reviewMode) {
            return false;
        }
        return  !(store.state.dueDiligenceRecord.status == 'approved' || store.state.user) || (store.state.editDueDiligence && store.state.user)
    }
)


const companyData = computed(() => store.state.companyData);
const aggree = ref({
    confirm: false,
    confirm2: false,
})

async function deleteReport(){
    const result = await API.deleteObject(props.item_id, 'due_diligence_record', 'Due Diligence Record');
    if (result) {
        router.push({name: 'due-diligence', params: {id: store.state.companyData._id}});
        store.commit('setDueDiligenceRecord', {});
        store.commit('setDueDiligenceElements', []);
        store.commit('setEditDueDiligence', false);
    } else {
        store.dispatch('addNotification', {text: `Error deleting`, type: 'error'});
    }
}

async function submitForm() {
    let checkValidate = await store.dispatch('checkDueDiligenceElements');
    console.log('checkValidate', checkValidate);
    if (checkValidate) {
        store.dispatch('addNotification', {text: 'Some of the required fields are missing in the form, please fill all of the needed information', type: 'error'});
        return;
    }
    // return;
    showSubmit.value = true; 
    ignoreWarning.value = false
}
function handleStateChange(type){
    if (type == 'approved') {
        // add check if files not uploaded
        confirmApprove.value = true;
    } else {
        confirmReject.value = true;
    }
}

function quillContent(event) {
    rejectComment.value = event.text
}

async function downloadPdf() {
    const element = document.getElementById('pdfContent');

    html2pdf()
    .set({
        margin: 10,
        filename: 'Due Dilligence Form.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] } // <-- Important!
    })
    .from(element)
    .save();
}

const loaded = ref(false);

function nameMap(type){

    switch (type) {
        case 'corporate_person':
            return 'Corporate Person';
        case 'corporate_shareholder':
            return 'Corporate Shareholder';
        case 'director':
            return 'Director';
        case 'shareholder':
            return 'Shareholder';
        case 'beneficiary':
            return 'Beneficiary';
        default:
            return '';
    }

}
const mainInfo = computed(() => {
    return store.state.dueDiligenceRecord;
});

const dueDiligenceCompany = computed(() => {
    return dueDiligenceElements.value.find(element => { 
        console.log('AAAAAAAAAAAAAAAA', element.type.value)
        return element.type.value === 'company' 
    });
});

const needUpdate = computed(() => {
    for(const el of dueDiligenceElements.value) {
        for (let key in el) {
            if (key == '_id') {
                continue;
            }
            if (el[key].new_value !== el[key].value && el[key].new_value) {
                return true;
            }
        }
    }
    for (let key in store.state.dueDiligenceRecord) {
        if (key == '_id') {
            continue;
        }
        if (['peps_present_details', 'interesting_past_details'].includes(key)) {
            let changedContent = commentValueChanged(store.state.dueDiligenceRecord[key]);
            if (changedContent) {
                return true;
            }
        } else if (store.state.dueDiligenceRecord[key].new_value !== store.state.dueDiligenceRecord[key].value && store.state.dueDiligenceRecord[key].new_value) {
            return true;
        }
    }
    return false;
});

function inputChangeFunc(event) {
    const event_type = event[0];
    const event_value = event[1];
    store.commit('updateDueDiligenceRecord', {
        updates: {
            [event_type]: event_value
        }
    })
}
function inputChangeFuncNew(event) {
    const event_type = event[0];
    const event_value = event[1];
    
    newCompany.value[event_type] = event_value;
}
function handleChange(field, event) {
    store.commit('updateDueDiligenceRecord', {
        updates: {
            [field]: event
        }
    })
}
function quillContentComment(event) {
    store.commit('updateDueDiligenceRecord',{
        updates: {
            [`${event.id}`]: event.structure,
        }
    })
}


function validateName() {
    nameError.value = false;
    if (!newCompany.value.name) {
        nameError.value = true;
        return;
    }
    return true;
}

async function updateReport(status) {
    if (status == 'approved') {
        confirmApprove.value = false;
    } else {
        confirmReject.value = false;
    }
    let response = await API.updateDueDiligenceState({
        id: props.item_id,
        status: status,
        comment: rejectComment.value
    });
    this.loadData();
}

async function submitReport(){
    changingState.value = true;
    try {
        await Save();
        let submisionResponse = await API.submitDueDiligenceReport({token: viewingToken.value}); 
        if (submisionResponse.status == 'success') {
            store.dispatch('addNotification', {text: `Successfully submitted`, type: 'success'});
            store.state.dueDiligenceRecord.status = 'submitted';
            showSubmit.value = false;
        } else {
            store.dispatch('addNotification', {text: `Error submitting`, type: 'error'});
        }
    } catch (error) {
        console.error('Error submitting report:', error);
        store.dispatch('addNotification', {text: `Error submitting`, type: 'error'});
    } finally {
        changingState.value = false;
    }
   
}

async function Save(){

    const elementsToSend = [];
    let recordToSend = null;

    savingData.value = true;

    for (let element of dueDiligenceElements.value) {
        
        const fieldsToSend = {
            _id: element._id,
        }
        for (let key in element) {
            if (['_id', 'due_diligense_id'].includes(key)) {
                continue;
            }
            if (element[key].new_value !== element[key].value && element[key].new_value) {
                fieldsToSend[key] = element[key].new_value;
            }
        }
        if (Object.keys(fieldsToSend).length > 1) {
            elementsToSend.push(fieldsToSend);
        }
    }
    let recordFields = {
    }
    for (let key in store.state.dueDiligenceRecord) {
        if (key == '_id') {
            continue;
        }
        if (store.state.dueDiligenceRecord[key].new_value !== store.state.dueDiligenceRecord[key].value && store.state.dueDiligenceRecord[key].new_value) {
            if (['peps_present_details', 'interesting_past_details'].includes(key)) {
                let oldValue = JSON.stringify(store.state.dueDiligenceRecord[key].value);
                let newValue = JSON.stringify(store.state.dueDiligenceRecord[key].new_value);
                console.log('oldValue', oldValue, 'newValue', newValue);
                if (oldValue !== newValue) {
                    console.log('aaaaaaaaaaaaa')
                    recordFields[key] = JSON.stringify(store.state.dueDiligenceRecord[key].new_value);
                }
            } else {
                recordFields[key] = store.state.dueDiligenceRecord[key].new_value;
            }
        }
    }
    if (Object.keys(recordFields).length > 0) {
        recordToSend = recordFields;
    }
    console.log('recordToSend', {recordToSend, recordFields});


    if (elementsToSend.length == 0 && !recordToSend) {
        console.log('Abort')
        savingData.value = false;
        return;
    }
    console.log('store.state.dueDiligenceRecord._id', store.state.dueDiligenceRecord);
    const resp = await API.saveDueDiligenceData({
        token: viewingToken.value,
        record: recordToSend, 
        elements: elementsToSend,
        id: store.state.dueDiligenceRecord._id
    });
    
    if (resp.status == 'success') {
        store.state.editDueDiligence = false;
        store.dispatch('addNotification', {text: `Successfully saved`, type: 'success'});
        await loadData();
        if (store.state.user) {
            store.dispatch('reloadNotification')
        }
        savingData.value = false;
    }

}

async function SaveElement() {
    if (!validateName()) {
        return;
    }
    addingNewLoading.value = true;
    const resp = await API.addDueDiligenceElement({token: viewingToken.value, type: showAddPopup.value, name: newCompany.value.name})
    if (resp.status == 'success') {
        addingNewLoading.value = true;
        newCompany.value.name = '';
        showAddPopup.value = false;
        nameError.value = false;
        let element = resp.element;
        initialStateElements.value = [JSON.parse(JSON.stringify(element)), ...initialStateElements.value];
        store.dispatch('setValue', {key: 'dueDiligenceElements', value: [element, ...dueDiligenceElements.value]});
        store.dispatch('addNotification', {text: `Successfully added new ${nameMap(showAddPopup)}`, type: 'success'});
    }
}
function AddNewElement(type) {
   showAddPopup.value = type;
}


async function loadData(){
    let data = await API.loadDueDiligenceData({token: viewingToken.value, id: props.item_id});
    if (!data?.dueDiligence) {
        store.dispatch('addNotification', {text: `Due Diligence Record not found`, type: 'error'});
        router.push({name: 'due-diligence', params: {id: props.id}});
        return;
    }
    store.dispatch('setValue', {key: 'dueDiligenceElements', value: data.elements});
    store.dispatch('setValue', {key: 'dueDiligenceRecord', value: data.dueDiligence});

    if (!companyData.value && props.id) {
        await API.loadDashboardData({company_id: props.id});
        store.dispatch('loadEnv', { id: props.id } );
    }
    companyName.value = data.compnanyName;
    store.state.kyc_files = [store.state.kyc_files, ...data.docs];
    loaded.value = true;
    initialStateElements.value = JSON.parse(JSON.stringify(data.elements));
    initialStatedueDiligence.value = JSON.parse(JSON.stringify(data.dueDiligence));
}
onMounted(async () => {
    await loadData();
    if (!store.state.user) {
        notificationOpen.value = true;
    }
    const options = [
        'us_applicant',
        'us_applicant_connect',
        'us_applicant_tag_related',   
        'politically_exposed_person',
        ];
        // options.forEach(option => {
        //     if (mainInfo.value[option].value) {
        //         let elementHTML = document.getElementById(`${mainInfo.value[option].value}-${option}`);
        //         if (elementHTML) {
        //             elementHTML.checked = true;
        //         }
        //     }
        // })
});

</script>

<style scoped lang="scss">
    
    .missing-file {
        display: list-item;
        list-style-type: disc;
    }
    .missing-file::marker {
        font-size: 1.2rem;
    }

    .close-section {
        position: absolute;
        left: -15px;
        top: 20px;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        display: flex;
        img {
            width: 30px;
        }

    }
    .notification-section {
        // overflow-y: auto;
        position: fixed;
        right: -300px;
        top: 60px;
        width: 300px;
        background: white;
        padding: 10px;
        padding-left: 20px;
        bottom: 0;
        border-left: 1px solid var(--border-color);
        border-top: 1px solid var(--border-color);
        transition: all 0.3s ease-in-out;
        box-sizing: border-box;
        
        .close-section {
            left: -40px;
        }
        &.opened {
            right: 5px;
            .close-section {
                transform: rotate(180deg);
                left: -25px;

            }
        }
    }
    .missing-files-section {
        pointer-events: none;
        opacity: 0.5;
    }
    .notifications {
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        overflow-y: auto;
    }
   
    .dd-status {

        margin-left: 10px;
        padding: 2px 5px;

        border-radius: 5px;
        font-size: 14px;
        font-weight: 600;
        color: white;
        &.dragted, &.submitted {
            background-color: rgba(128, 128, 128, 0.5);
        }
        &.approved {
            background-color: #008000;
        }
        &.rejected {
            background-color: #FF0000;
        }
    }
    .main-container {
        
        padding: 20px;
        background-color: #f9f9f9;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        padding-bottom: 50px;
    }
    .table-wrapper {
        width: 100%;
        max-width: 1350px;
    }
    .header-main {
        margin: 0;
        max-width: 1350px;
        
    }
    .section {
        align-items: flex-start;
        background: white;
        border-radius: 8px;
        padding: 20px;
        border: 1px solid var(--border-color);
        box-sizing: border-box;

    }
    .popup-content {
        &:deep(.popup-block) {
            width: 700px;

        }
    }
    .section-header {
        font-size: 16px;
        font-weight: 600;
        padding-left: 15px;
        margin-bottom: 10px;
        text-align: left;
    }
    .markdown-content {
        max-height: 230px;
        height: 250px;
    }
    .info-table {
        text-align: left;
        width: 100%;
        tr {
            td, th {
                padding: 0px;
                border-bottom: 1px solid var(--border-color);

            }
            th {
                vertical-align: top;
                padding-left: 5px;
            }
            td:not(.small) {
                border-left: 1px solid var(--border-color);
                width: 60%;

                &:deep(.styled-input) {
                    margin-bottom: 0;
                }
            }
        }
    }
    .confirm-submit.container {
        width: 600px;
        max-height: 90vh;
        overflow-y: auto;
       
        .save-button {
            width: fit-content;
        }
    }
    .approve-review.container {
        &.missing-files {
            width: 600px;
        }
        width: 450px;
        min-height: unset;
    }

    .width-big {
        width: 50%;
    }
    .yes-no {
        td {
            width: 25%;
        }
    }
    .body-content {
        // font-weight: 600;
    }
    input[type="radio"] {
        margin: 0 5px;
        width: 20px;
        height: 25px;
        margin: auto;
        border: unset;
        outline: unset;
    }
    .small[class] {
        padding-top: 4px;
        text-align: center;
    }
    .due-elements {
        display: flex;
        flex-direction: column;
        gap: 100px;
        margin-bottom: 20px;
        width: 100%;
    }
    .save-area {

        position: fixed;
        bottom: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
      
        width: 100%;
        z-index: 1000;

    }
    .save-area-inner {
        position: relative;
        // left: 20px;
        max-width: 1350px;
        width: 100%;
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        background: white;
        border: 1px solid var(--border-color);
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        justify-content: flex-start;
        align-items: center;
        padding: 5px;
        button {
            height: 35px;
            margin-left: unset;
        }
    }
    .loading {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 30px;
    }
  
    .submit-section {
        max-width: 1350px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }
.message-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-height: calc(100vh - 250px);
    overflow-y: auto;
    padding: 1rem 1.5rem;
}
.message-content {
    font-size: 0.9rem;
    line-height: 1.5rem;
    color: rgb(24 28 34);
    text-align: left;
    &:deep(p) {
        margin: 0;
    }
}

.message-author {
    text-align: left;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    word-break: break-word;
    color: black;
}
.message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.message-date {
    color: rgb(91 94 102);
    background: rgb(224 226 236);
    border-radius: .125rem;
    height: 1rem;
    text-wrap: nowrap;
    width: fit-content;
    font-size: .75rem;
    font-weight: 700;
    line-height: 1rem;
    padding: .125rem;
}
.message {
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    background-color: rgb(246 246 252);
    border: 1px solid var(--border-color);
    padding: .75rem;
}
.missing {
    pointer-events: none;
    opacity: 0.5;
}
.border {
    border: 1px solid var(--border-color);
}
.border-red-500[class] {
    border-color: red;
}
.text-red-500 {
    color: red;
    font-size: 10px;
    padding-left: 10px;
}
.border-error {
    border: 1px solid red;
}


</style>